import { config, library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faArrowDown,
  faArrowDownArrowUp,
  faArrowLeft,
  faArrowPointer,
  faArrowProgress,
  faArrowRight,
  faArrowsLeftRightToLine,
  faArrowsLeftRight,
  faArrowsRotate,
  faArrowsTurnRight,
  faArrowTurnDownRight,
  faArrowTurnLeft,
  faArrowTurnRight,
  faArrowUp,
  faArrowUpRightFromSquare,
  faBagShopping,
  faBell,
  faBellOn,
  faBolt,
  faBook,
  faBoxArchive,
  faBriefcase,
  faBuilding,
  faCalendar,
  faCamera,
  faCartShopping,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faCircleRight,
  faCircleXmark,
  faClipboard,
  faClockRotateLeft,
  faCloudArrowUp,
  faCodeBranch,
  faCodeMerge,
  faCommentLines,
  faCopy,
  faCreditCard,
  faDollarSign,
  faDown,
  faDownload,
  faEllipsisV,
  faEnvelope,
  faExclamationCircle,
  faExclamationTriangle,
  faExpandArrows,
  faEye,
  faEyeSlash,
  faFaceSmile,
  faFile,
  faFileCircleQuestion,
  faFileCode,
  faFileCsv,
  faFileDashedLine,
  faFileExcel,
  faFileExport,
  faFileGif,
  faFileImage,
  faFileInvoice,
  faFileJpg,
  faFilePdf,
  faFilePlus,
  faFilePng,
  faFilePowerpoint,
  faFileWord,
  faFloppyDisk,
  faFolderTree,
  faGear,
  faGlobe,
  faGrid2Plus,
  faGripDotsVertical,
  faHand,
  faHashtag,
  faHourglassHalf,
  faHourglassStart,
  faInbox,
  faKeyboard,
  faLeft,
  faListCheck,
  faListTimeline,
  faLock,
  faMagnifyingGlass,
  faMailbox,
  faMicrochipAi,
  faMinus,
  faPaperclip,
  faPen,
  faPenToSquare,
  faPhone,
  faPlay,
  faPlus,
  faPrint,
  faQuestion,
  faQuestionCircle,
  faReceipt,
  faRight,
  faRightFromBracket,
  faRobot,
  faSearch,
  faShare,
  faShield,
  faSitemap,
  faSparkle,
  faSparkles,
  faSpinnerScale,
  faSpinnerThird,
  faSplit,
  faSuitcase,
  faTableLayout,
  faTag,
  faTally1,
  faTally2,
  faTally3,
  faThumbsUp,
  faTimer,
  faTimes,
  faTrash,
  faTrashAlt,
  faTriangleExclamation,
  faTruck,
  faUp,
  faUpload,
  faUser,
  faUserCheck,
  faUserMagnifyingGlass,
  faUserPen,
  faUserPoliceTie,
  faUsers,
  faUserShield,
  faUserTag,
  faUserXmark,
  faWarning,
  faXmark,
  faCalendarClock,
  faChevronUp, faFilePen, faArrowUpArrowDown, faDesktop,
} from '@awesome.me/kit-120eb18957/icons/classic/regular';

import {
  faRegularArrowProgressCircleCheck,
  faRegularArrowProgressCircleXmark,
  faRegularArrowProgressTag,
  faRegularCodeBranchCircleXmark,
  faRegularGearGear,
  faRegularInboxSparkle,
  faRegularMicrochipAiCirclePlus,
  faRegularTriangleExclamationUser,
  faRegularUserCircleArrowRight,
  faRegularUserSignal,
  faRegularUsersPen,
  faRegularFileSparkle,

} from "@awesome.me/kit-120eb18957/icons/kit/custom";
// This is important, we are going to let Nuxt worry about the CSS
config.autoAddCss = false;
config.measurePerformance = true;

// Adding icons to the library
const icons = [
  faPlus,faArrowUpArrowDown, faPlay, faMinus, faCheck, faXmark, faTimes, faArrowRight, faArrowLeft, faArrowUpRightFromSquare, faGrid2Plus,
  faArrowTurnLeft, faArrowTurnRight, faChevronLeft, faChevronRight, faChevronDown, faChevronUp, faRight, faLeft, faUp, faDown,
  faExpandArrows, faArrowsRotate, faArrowProgress, faArrowPointer, faArrowDown, faArrowDownArrowUp, faArrowTurnDownRight, faArrowsTurnRight, faCircleRight, faSpinnerThird, faSpinnerScale, faTimer, faUser, faUsers,
  faUserCheck, faRegularUserCircleArrowRight, faUserPen, faUserTag, faUserXmark, faUserPoliceTie, faUserShield, faUserMagnifyingGlass, faThumbsUp, faHand, faFaceSmile, faFile, faFileInvoice, faFilePlus, faFileExport, faFileDashedLine,
  faFolderTree, faBoxArchive, faBolt, faRobot, faBellOn, faBell, faCircleCheck, faCircleXmark, faCircleExclamation,
  faCheckCircle, faWarning, faTriangleExclamation, faExclamationTriangle, faCircleInfo, faMagnifyingGlass,
  faSearch, faQuestion, faQuestionCircle, faShield, faCartShopping, faInbox, faHashtag, faCommentLines, faCodeBranch,
  faClockRotateLeft, faListCheck, faHourglassStart, faHourglassHalf, faReceipt, faClipboard,
  faBook, faCalendar, faCamera, faTruck, faSplit, faTag, faTrash, faTrashAlt, faShare, faKeyboard, faSparkles, faSparkle,
  faGlobe, faPaperclip, faPhone, faEye, faEyeSlash, faCreditCard, faArrowsLeftRightToLine, faArrowsLeftRight, faExclamationCircle,
  faEnvelope, faTableLayout, faTally3, faTally2, faTally1, faEllipsisV,
  faGripDotsVertical, faGear, faLock, faCloudArrowUp, faArrowUp, faDollarSign, faBagShopping, faListTimeline, faSuitcase,
  faRightFromBracket, faUpload, faDownload, faFileCode, faFilePen, faFileImage, faFilePdf, faFileWord, faFileCsv, faFileExcel, faFilePowerpoint, faFileCircleQuestion,
  faFileJpg, faFileGif, faFilePng, faBuilding, faBriefcase, faRegularTriangleExclamationUser, faRegularUserSignal, faRegularInboxSparkle, faRegularUsersPen, faRegularGearGear,
  faCopy, faMicrochipAi, faRegularMicrochipAiCirclePlus, faMailbox, faRegularArrowProgressCircleXmark, faRegularCodeBranchCircleXmark, faFloppyDisk, faSitemap, faCodeMerge, faPrint, faPenToSquare, faPen,
  faRegularArrowProgressCircleCheck, faRegularArrowProgressTag, faRegularFileSparkle, faCalendarClock, faDesktop
];

library.add(...icons);

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component("font-awesome-icon", FontAwesomeIcon);
});